import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '../menu/Menu';
import Tile from '../common/Tile';
import '../common/rtCommon.css';
import '../common/Tile.css';
import './SettingsManagement.css';

const tiles = [
  {
    icon: '🔒',
    title: 'Change Password',
    description: 'Update your account password for security',
    url: 'change-password',
    access_roles: ['RT_Admin', 'RT_Staff', 'RT_PayingGuest', 'RT_NoAccess'] // All roles can change password
  },
  {
    icon: '💰',
    title: 'Payment Settings',
    description: 'Configure payment types, methods, invoice generation dates, and transaction charges',
    url: 'payment-settings',
    disabled: false,
    access_roles: ['RT_Admin'] // Admin only
  },
  {
    icon: '📱',
    title: 'WhatsApp Settings',
    description: 'Configure messaging templates and settings',
    url: 'whatsapp-settings',
    disabled: false,
    access_roles: ['RT_Admin'] // Admin only
  }
];

const SettingsManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="rt-layout">
      <Menu className="rt-menu" activePath={location.pathname} />
      <div className="rt-main-content">
        <div className="rt-title-row">
          <h2 className="rt-title">Settings</h2>
        </div>
        <div className="rt-main-section">
          <div className="rt-tiles-grid">
            {tiles.map((tile, idx) => (
              <Tile
                key={idx}
                icon={tile.icon}
                title={tile.title}
                description={tile.description}
                disabled={tile.disabled}
                access_roles={tile.access_roles}
                onClick={() => tile.url && navigate(tile.url)}
                tabIndex={0}
                role="button"
                onKeyPress={e => { if (e.key === 'Enter' && tile.url) navigate(tile.url); }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsManagement;
